import React, { Component } from 'react'
import styles from './ErrorBoundary.module.less'
import { commonUtils } from '@/helpers/commonUtils'
import AButton from '../A/AButton/AButton'
import { Link } from 'react-router-dom'

interface Props {
  children: React.ReactNode
}

export class ErrorBoundary extends Component<any, { hasError: boolean; error: any }> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error }
  }

  componentDidCatch(error: any, info: any) {
    // Example "componentStack":
    //   in ComponentThatThrows (created by App)
    //   in ErrorBoundary (created by App)
    //   in div (created by App)
    //   in App
    // logErrorToMyService(error, info.componentStack);
    console.error('error', error.message)
    console.error('info', info)
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      // return this.props.fallback;
      return <ErrorBoundaryFallback error={this.state.error.message} />
    }
    return this.props.children
  }
}

function ErrorBoundaryFallback(props: { error: any }) {
  return (
    <div className={styles.errorBoundaryFallback}>
      <div className={styles.fallbackContent}>
        <div className={styles.cardBox}>
          <img src={commonUtils.getImagePath('homePage/adeff-logo.png')} alt='' />
          <p> An error occurred in the application </p>
          <p>please contact us for processing.</p>
          <p style={{ marginTop: 12 }}>Error msgs: </p>
          <p style={{ marginTop: 8 }} className={styles.errorMsg}>
            {props.error}
          </p>
        </div>
        <Link to='/' style={{ textDecoration: 'none', marginTop: 12 }}>
          <AButton type='primary' testId='error-boundary-go-back-btn'>go back</AButton>
        </Link>
      </div>
    </div>
  )
}
